import Moderator from '@/models/bread/Moderator/tuition'

export default {
  key:'Tuition',
  name:{
    singular:'Tuition',
    plural:'Tuitions',
  },
  parents:[
   
  ],
  Admin:false,
  Moderator:Moderator,
  Teacher:false,
}